<div id="jsoneditor" [ngClass]="{'read-only': readOnly, 'hide-line-numbers': !showLineNumbers}" #editor (keyup.enter)="enterKeyPressed($event)" (keyup)="jsonChanged($event)"></div>
<div *ngIf="showCopy" class="icon-copy copy-text" (click)="copyToClipboad()"></div>
